import { gql } from 'apollo-angular';

const GET_RFP_CROSS_REFERENCE_DOWNLOAD = gql`
  query GetRfpCrossReferenceDownload($rfpId: Long) {
    rfpCrossReferenceDownload(rfpId: $rfpId) {
      url
    }
  }
`;

export default GET_RFP_CROSS_REFERENCE_DOWNLOAD;

